import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { useAuth } from "../../authentication";
import { useHistory } from "react-router-dom";
import "./custom-avatar-style.css";
import {
  ClearEditPtntRecord,
  setAdmittedPatientDetails,
  setPatientDetails,
  setAdmittedPatientInfoBarData,
  setNurseAdmittedPatientDetails,
  setPatientInfoBarData,
  setPatientDiagnosisHistory,
} from "../../appRedux/actions";
import { setBillingAccessedData } from "../../appRedux/actions";
import { useDispatch, useSelector } from "react-redux";
import { baseUrl2 } from "../../util/Api";
import { useHospitalName } from "../../util/hooks/useHospitalName";
import { LockOutlined, LogoutOutlined } from "@ant-design/icons";
import ResetPasswordModal from "./ResetPasswordModal";

const UserInfo = () => {
  const dispatch = useDispatch();
  const { userSignOut, getLogout, authUser } = useAuth();
  const history = useHistory();
  const [imageLoadError, setImageLoadError] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isResetPasswordVisible, setIsResetPasswordVisible] = useState(false);

  const hospitalRecords = useSelector(
    ({ addHospital }) => addHospital.hospitalsRecord,
  );
  const currentHospital = hospitalRecords?.find(
    (data) => data.HsptID === authUser?.User?.HospitalID,
  );
  const { currentUser } = useHospitalName();

  const clearAllCookies = () => {
    document.cookie.split(";").forEach((cookie) => {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`;
      const domain = window.location.hostname.split(".").slice(-2).join(".");
      if (domain !== window.location.hostname) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${domain}`;
      }
    });
  };

  const onLogoutClick = () => {
    userSignOut(() => {
      dispatch(ClearEditPtntRecord());
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      dispatch(setPatientDetails({}));
      dispatch(
        setPatientDiagnosisHistory({
          PDH: [],
          PILH: [],
          PIRH: [],
          PMH: [],
          PEH: [],
        }),
      );
      dispatch(setAdmittedPatientDetails({}));
      dispatch(setBillingAccessedData({}));
      dispatch(setNurseAdmittedPatientDetails({}));
      dispatch(setPatientInfoBarData({}));
      dispatch(setAdmittedPatientInfoBarData({}));
      clearAllCookies();
      getLogout();
      history.push("/signin");
    });
  };

  const showResetPasswordModal = () => {
    console.log("Reset Password clicked!");
    setIsResetPasswordVisible(true);
    console.log("Modal state set to true");
  };

  const handleResetPasswordClose = () => {
    setIsResetPasswordVisible(false);
  };

  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li className="gx-menu-item" onClick={showResetPasswordModal}>
        <LockOutlined className="gx-menu-icon" />
        <span>Change Password</span>
      </li>
      <li className="gx-menu-item gx-logout-item" onClick={onLogoutClick}>
        <LogoutOutlined className="gx-menu-icon" />
        <span>Logout</span>
      </li>
    </ul>
  );

  const handleImageError = () => {
    console.log(
      "Image failed to load:",
      `${baseUrl2}${currentHospital?.logoUrl}`,
    );
    setImageLoadError(true);
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
    setImageLoadError(false);
  };

  const logoUrl = currentHospital?.logoUrl
    ? `${baseUrl2}${currentHospital.logoUrl}`
    : null;

  const renderFallback = () => (
    <div
      style={{
        width: "13mm",
        height: "13mm",
        borderRadius: "50%",
        backgroundColor: "#f0f0f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        border: "1px solid #d9d9d9",
      }}
    >
      <span style={{ color: "#999", fontSize: "14px" }}>Logo</span>
    </div>
  );

  const renderImage = () => (
    <>
      <img
        src={logoUrl}
        alt=""
        style={{
          width: "13mm",
          height: "12mm",
          borderRadius: "50%",
          objectFit: "cover",
          cursor: "pointer",
          border: "1px solid #e5e7eb",
          display: imageLoadError ? "none" : "block",
          boxShadow:
            "0 4px 6px -1px rgba(41, 52, 142, 0.15), 0 2px 4px -1px rgba(41, 52, 142, 0.1)",
          transition: "all 0.3s ease",
        }}
        onError={handleImageError}
        onLoad={handleImageLoad}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow =
            "0 20px 25px -5px rgba(41, 52, 142, 0.25), 0 10px 10px -5px rgba(41, 52, 142, 0.15)";
          e.currentTarget.style.transform = "translateY(-2px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow =
            "0 4px 6px -1px rgba(41, 52, 142, 0.15), 0 2px 4px -1px rgba(41, 52, 142, 0.1)";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      />

      {imageLoadError && renderFallback()}
    </>
  );

  return (
    <>
      <Popover
        overlayClassName="gx-popover-horizantal gx-user-info-popover"
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
        align={{
          offset: [0, 8],
        }}
      >
        <div>
          {logoUrl && !imageLoadError ? renderImage() : renderFallback()}
        </div>
      </Popover>

      <ResetPasswordModal
        visible={isResetPasswordVisible}
        onClose={handleResetPasswordClose}
      />
    </>
  );
};

export default UserInfo;
